import React from 'react';
import PropTypes from 'prop-types';

import { childrenPropType } from 'src/lib/prop-types';

export function Grid({ maxColumns, className, children }) {
  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${Math.min(2, maxColumns)} lg:grid-cols-${Math.min(
        3,
        maxColumns,
      )} xl:grid-cols-${maxColumns} gap-3 ${className}`}
    >
      {children}
    </div>
  );
}

Grid.propTypes = {
  maxColumns: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: childrenPropType,
};

Grid.defaultProps = {
  className: null,
  children: null,
};
